import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { HomeProps } from '@interfaces/homepage';
import { Page } from '@tracking';

import MainFeed from '../../MainFeed';
import SideFeed from './SideFeed';

const HomeContent = ({
  sideFeedAdvertisement,
  briefingNewsletter,
  communityComments,
  featuredArticles,
  feedContent,
  feedUnits,
  featuredPartners,
  latestProArticles,
  page,
  recommendedArticles,
  upcomingEvents,
  view,
}: HomeProps) => {
  const { Track } = useEventTracking({ page: Page.Homepage });

  return (
    <Track>
      <div className="px-0 sm:px-28">
        <div className="m-auto max-w-container-lg">
          <div className="flex">
            <div className="w-full md:max-w-[740px] md:pr-28 lg:max-w-[940px] lg:pr-56">
              <MainFeed
                featuredArticles={featuredArticles}
                feedContent={feedContent}
                feedUnits={feedUnits}
                view={view}
                page={page}
              />
            </div>
            <div
              className="hidden flex-1 border-0 border-l border-solid border-grayscale-gray md:block md:pl-28 lg:pl-56"
              data-testid="side-feed"
            >
              <SideFeed
                advertisement={sideFeedAdvertisement}
                briefingNewsletter={briefingNewsletter}
                communityComments={communityComments}
                featuredPartners={featuredPartners}
                latestProArticles={latestProArticles}
                recommendedArticles={recommendedArticles}
                upcomingEvents={upcomingEvents}
              />
            </div>
          </div>
        </div>
      </div>
    </Track>
  );
};

export default HomeContent;
